import api from "../../../api/axios";

// PRIVATE-FINANCE-HUB-B1 — owner-scoped Hub list + summary transport.
// Quick-add payments reuse createDealMyFinancePayment from dealPrivateFinance.js.

export const fetchMyFinanceHub = (params = {}, { signal } = {}) =>
  api
    .get("/realty/my-finance/", { params, signal })
    .then((res) => res.data);
